import styles from './style.module.css';
import Chat from './components/chat/Chat';

function App() {
  return (
    <div className={styles.screen} onClickCapture={() => {}}>
      <Chat />
    </div>
  );
}

export default App;
